import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

import { Utils } from 'src/services/utils';

@Component({
    selector: 'rm-pre-inner-batch-label',
    templateUrl: './pre-inner-batch-label.component.html',
    styleUrls: ['./pre-inner-batch-label.component.css']
})

export class PreInnerBatchLabelComponent implements OnInit {
    selectedBatch: any;
    selected: any = null;
    batchLabelRec: any;
    currentOrgObj: any;
    grossValue: number = null;
    tareValue: number = null;
    netValue: number = null;
    containerValue: number = null;
    totalNetWeight: number = 0;

    constructor(
        private dialogRef: MatDialogRef<PreInnerBatchLabelComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private utils: Utils,
    ) { }

    ngOnInit(): void {
        this.batchLabelRec = this.data.batchLabel;
        this.currentOrgObj = this.data.currentOrgObj;
        if (this.data.actionType === 'update') {
            this.grossValue = this.batchLabelRec.innerLabels[this.data.innerLabelIdx].grossweight;
            this.tareValue = this.batchLabelRec.innerLabels[this.data.innerLabelIdx].tareweight;
            this.containerValue = this.batchLabelRec.innerLabels[this.data.innerLabelIdx].container;

            // the label stores gross and tare, so the net box has to be seeded
            // from their difference - at display precision, or it shows float noise
            if (this.isNetWeightEntry) {
                this.netValue = Number((this.grossValue - this.tareValue)
                    .toFixed(this.currentOrgObj.labelWeightDecimals ? this.currentOrgObj.labelWeightDecimals : 3));
            }
        }
    }

    cancel() {
        this.dialogRef.close();
    }

    /**
     * Some orgs work from the tare of the empty container and the net quantity
     * filled into it, so they enter those two and gross is the computed sum.
     */
    get isNetWeightEntry(): boolean {
        return !!(this.currentOrgObj && this.currentOrgObj.isNetWeightEntered);
    }

    /** live gross for the read only box; null until both operands are filled */
    get computedGrossValue(): number {
        return this.utils.grossFromTareAndNet(this.tareValue, this.netValue);
    }

    addPreInner() {
        const gross = this.isNetWeightEntry ? this.computedGrossValue : this.grossValue;

        if (gross && this.tareValue && this.containerValue) {
            if (this.data.actionType === 'update') {
                this.batchLabelRec.innerLabels[this.data.innerLabelIdx].grossweight = gross;
                this.batchLabelRec.innerLabels[this.data.innerLabelIdx].tareweight = this.tareValue;
                this.batchLabelRec.innerLabels[this.data.innerLabelIdx].container = this.containerValue;
                this.batchLabelRec.innerLabels[this.data.innerLabelIdx].netweight = (gross - this.tareValue).toFixed(this.currentOrgObj.labelWeightDecimals ? this.currentOrgObj.labelWeightDecimals : 3);
            } else {
                let newPreInnerLabel = {
                    grossweight: gross,
                    tareweight: this.tareValue,
                    container: this.containerValue,
                    parentContainer: this.batchLabelRec.container,
                    isAlsoInner: false,
                    isOnlyInner: true,
                    netweight: (gross - this.tareValue).toFixed(this.currentOrgObj.labelWeightDecimals ? this.currentOrgObj.labelWeightDecimals : 3),
                    actions: [{ name: 'close', tip: 'delete' }]
                }
                if (this.batchLabelRec.innerLabels === undefined) {
                    this.batchLabelRec.innerLabels = [];
                }
                this.batchLabelRec.innerLabels.push(newPreInnerLabel);
            }
            this.dialogRef.close({ data: { ...this.batchLabelRec } })
        }
    }
} 